import { Modal as PayloadModal, useModal } from '@payloadcms/ui';

import { XMarkIcon } from '../icons/XMarkIcon';

import './styles.scss';

interface ModalProps extends React.ComponentProps<typeof PayloadModal> {
  enableCloseXmark?: boolean;
}

export const Modal = ({ children, enableCloseXmark = true, ...props }: ModalProps) => {
  const { closeModal } = useModal();

  return (
    <PayloadModal role="dialog" {...props} className={['fv-modal', props.className].filter(Boolean).join(' ')}>
      {enableCloseXmark && (
        <button
          className="fv-modal__close-button"
          type="button"
          onClick={() => {
            closeModal(props.slug);
          }}
          aria-label="Close modal"
        >
          <XMarkIcon aria-hidden="true" />
        </button>
      )}
      {children as React.ReactNode}
    </PayloadModal>
  );
};
